import { ListingList } from 'app/components/listing-list';
import { ListingOfferCardSmall } from 'app/components/listing-offer-card.small';
import React from 'react';
import type { ProfileListingResults } from './shared';
import { ProfileListingEmpty } from './profile-listing-empty';

export function PlaceRegularListings({
  results,
  searchQuery,
  setSearchQuery,
}: {
  results: ProfileListingResults;
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
}) {
  return (
    <ListingList
      filters={results.filters}
      data={results.listings}
      isLoading={results.isLoading}
      isFetchingNextPage={results.query.isFetchingNextPage}
      numListingsTotal={results.total}
      onRefresh={results.query.resetThenRefetch}
      refreshing={results.query.isRefetching}
      byPassFixedHeight
      scrollEnabled={false}
      searchQuery={searchQuery}
      onSearchQueryChange={setSearchQuery}
      card={ListingOfferCardSmall}
      listFormat="grid"
      presentation={{ requestBanner: 'hidden', searchBar: 'visible', user: 'hidden' }}
      ListEmptyComponent={<ProfileListingEmpty translationKey="place.noListingsOffer" />}
    />
  );
}
